import { bootstrap } from 'ng-metadata/platform';
import { AppModule } from './app/app';

bootstrap( AppModule );



/** WEBPACK FOOTER **
 ** ./src/bootstrap.ts
 **/